import * as EmailValidator from "email-validator";
import React, { useState } from "react";
import { Link, Route, Switch } from "react-horizontal-router-dom";
import { useSelector } from "react-redux";

import {
  loginUser,
  resetPassword,
  resetPasswordRequest,
  resetPasswordVerifyOTP,
  signup,
  verifyOTP
} from "../../actions/user-actions/auth";
import useActions from "../../hooks/useActions";
import backgroundImage from "../../images/login-background.png";
import baseLogo from "../../images/logo.png";

const Signup = props => {
  const { openLink } = props;
  const auth = useSelector(state => state.auth);
  const actions = useActions({ signup });
  const [name, setName] = useState("");
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [nameValid, setNameValid] = useState(true);
  const [userNameValid, setUserNameValid] = useState(true);
  const [emailValid, setEmailValid] = useState(true);
  const [phoneValid, setPhoneValid] = useState(true);
  const [passwordValid, setPasswordValid] = useState(true);

  const moveCaretAtEnd = event => {
    const { value } = event.target;
    event.target.value = "";
    event.target.value = value;
  };

  const handleCreateAccount = event => {
    event.preventDefault();
    event.stopPropagation();
    const nameValid = name.trim().length > 0;
    const userNameValid = userName.trim().length > 0;
    const emailValid =
      email.trim().length === 0 || EmailValidator.validate(email);
    const phoneValid = parseInt(phone).toString().length === 10;
    const passwordValid = password.length >= 6;

    if (
      nameValid &&
      userNameValid &&
      emailValid &&
      phoneValid &&
      passwordValid
    ) {
      actions.signup(
        name.trim(),
        userName.trim(),
        phone,
        email,
        password,
        openLink
      );
    } else {
      setNameValid(nameValid);
      setUserNameValid(userNameValid);
      setEmailValid(emailValid);
      setPhoneValid(phoneValid);
      setPasswordValid(passwordValid);
    }
  };

  const handleNameChange = event => {
    setName(event.target.value);
    setNameValid(true);
  };

  const handleUserNameChange = event => {
    setUserName(event.target.value);
    setUserNameValid(true);
  };

  const handleEmailChange = event => {
    setEmail(event.target.value);
    setEmailValid(true);
  };

  const handlePhoneChange = event => {
    setPhone(event.target.value);
    setPhoneValid(true);
  };

  const handlePasswordChange = event => {
    setPassword(event.target.value);
    setPasswordValid(true);
  };

  return (
    <div className="flex w-full flex-col items-center">
      <h1 className="text-2xl">Create Account</h1>
      {auth.error && (
        <div className="mt-2 flex rounded border border-red-600 p-2">
          <div>
            <span>
              <i className="material-icons pr-2 text-2xl text-red-600">error</i>
            </span>
          </div>
          <div>
            <span className="text-sm text-red-600">There was a problem</span>
            <br />
            <span className="text-xs">
              Your email address or phone number was previously registered.
            </span>
          </div>
        </div>
      )}
      <form onSubmit={handleCreateAccount} className="w-full max-w-md">
        <div className="mt-4">
          <label className="mb-2 text-xs text-gray-600">Name</label>
          <div>
            <input
              type="text"
              required
              value={name}
              onChange={handleNameChange}
              onFocus={moveCaretAtEnd}
              className="h-10 w-full rounded bg-gray-200 px-4"
            />
            {!nameValid && (
              <span className="text-xs text-red-600">Invalid name</span>
            )}
          </div>
        </div>

        <div className="mt-2">
          <label className="mb-2 text-xs text-gray-600">Business Name</label>
          <div>
            <input
              type="text"
              required
              value={userName}
              onChange={handleUserNameChange}
              onFocus={moveCaretAtEnd}
              className="h-10 w-full rounded bg-gray-200 px-4"
            />
            {!userNameValid && (
              <span className="text-xs text-red-600">Invalid user name</span>
            )}
          </div>
        </div>

        <div className="mt-2">
          <label className="mb-2 text-xs text-gray-600">Email</label>
          <div>
            <input
              type="text"
              required
              value={email}
              onChange={handleEmailChange}
              onFocus={moveCaretAtEnd}
              className="h-10 w-full rounded bg-gray-200 px-4"
            />
            {!emailValid && (
              <span className="text-xs text-red-600">
                Invalid email address
              </span>
            )}
          </div>
        </div>

        <div className="mt-2">
          <label className="mb-2 text-xs text-gray-600">Mobile Number</label>
          <div>
            <input
              type="text"
              required
              value={phone}
              onChange={handlePhoneChange}
              onFocus={moveCaretAtEnd}
              className="h-10 w-full rounded bg-gray-200 px-4"
            />
            {!phoneValid && (
              <span className="text-xs text-red-600">
                Invalid mobile number
              </span>
            )}
          </div>
        </div>

        <div className="mt-2">
          <label className="mb-2 text-xs text-gray-600">Password</label>
          <div>
            <input
              type="password"
              required
              value={password}
              onChange={handlePasswordChange}
              onFocus={moveCaretAtEnd}
              className="h-10 w-full rounded bg-gray-200 px-4"
            />
            {!passwordValid && (
              <span className="text-xs text-red-600">
                Password should have at least 6 characters
              </span>
            )}
          </div>
        </div>

        <button
          type="submit"
          disabled={auth.isAuthenticating}
          className="mt-6 h-12 w-full rounded-full bg-pink-600 font-medium text-white">
          Create Account
        </button>
      </form>
    </div>
  );
};

const Login = () => {
  const auth = useSelector(state => state.auth);
  const actions = useActions({ loginUser });
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [userNameValid, setUserNameValid] = useState(true);
  const [passwordValid, setPasswordValid] = useState(true);

  const moveCaretAtEnd = event => {
    const { value } = event.target;
    event.target.value = "";
    event.target.value = value;
  };

  const handleLogin = event => {
    event.preventDefault();
    event.stopPropagation();
    const userNameValid =
      EmailValidator.validate(userName) ||
      parseInt(userName).toString().length === 10;
    const passwordValid = password.length >= 6;
    if (userNameValid && passwordValid) {
      actions.loginUser(userName, password);
    } else {
      setUserNameValid(userNameValid);
      setPasswordValid(passwordValid);
    }
  };

  const handleUserNameChange = event => {
    setUserName(event.target.value);
    setUserNameValid(true);
  };

  const handlePasswordChange = event => {
    setPassword(event.target.value);
    setPasswordValid(true);
  };

  return (
    <div className="m-h-800 flex flex-col items-center">
      <h1 className="text-2xl">Login</h1>
      {auth.error && (
        <div className="mt-6 w-full rounded-md border border-red-600">
          <div className="flex p-2">
            <div>
              <span>
                <i className="material-icons pr-2 text-2xl text-red-600">
                  error
                </i>
              </span>
            </div>
            <div>
              <span className="text-sm text-red-600">There was a problem</span>
              <br />
              <span className="text-xs">
                Your account does not exist or password is not valid
              </span>
            </div>
          </div>
        </div>
      )}
      <form onSubmit={handleLogin} className="w-full max-w-md">
        <div className="mt-6">
          <label className="mb-2 text-xs text-gray-500">
            Email / Mobile Number
          </label>
          <div>
            <input
              type="text"
              required
              value={userName}
              onChange={handleUserNameChange}
              onFocus={moveCaretAtEnd}
              className="h-10 w-full rounded bg-gray-200 px-4"
            />
            {!userNameValid && (
              <span className="mt-2 block text-xs text-red-600">
                Invalid email address / mobile number
              </span>
            )}
          </div>
        </div>

        <div className="mt-6">
          <div className="mb-2 flex justify-between">
            <label className="text-xs text-gray-500">Password</label>
            <Link to="/auth/forgot-password">
              <span className="text-xs text-gray-500">
                Forgot your password?
              </span>
            </Link>
          </div>
          <div>
            <input
              type="password"
              required
              value={password}
              onChange={handlePasswordChange}
              onFocus={moveCaretAtEnd}
              className="h-10 w-full rounded bg-gray-200 px-4"
            />
            {!passwordValid && (
              <span className="mt-2 block text-xs text-red-600">
                Password should have at least 6 characters
              </span>
            )}
          </div>
        </div>

        <button
          type="submit"
          disabled={auth.isAuthenticating}
          className="mt-6 h-12 w-full rounded-full bg-pink-600 font-medium text-white">
          Login
        </button>
      </form>
    </div>
  );
};

const VerifyOTP = props => {
  const { openLink, location } = props;
  const actions = useActions({ resetPasswordVerifyOTP, verifyOTP });
  const { isAuthenticating, error } = useSelector(state => state.auth);
  const [otp, setOTP] = useState("");
  const [otpValid, setOTPValid] = useState(true);

  const phone = location.query.phone;

  const moveCaretAtEnd = event => {
    const { value } = event.target;
    event.target.value = "";
    event.target.value = value;
  };

  const handleOTPChange = event => {
    setOTP(event.target.value);
    setOTPValid(true);
  };

  const handleVerifyOTP = event => {
    event.preventDefault();
    event.stopPropagation();
    const reset = location.query.reset;
    const genericId = location.query.generic;
    const phone = location.query.phone;
    if (reset === "true") {
      actions.resetPasswordVerifyOTP(otp, genericId, phone, openLink);
    } else {
      actions.verifyOTP(otp, genericId, phone);
    }
  };

  const handleResendCode = () => {
    console.log("resend otp API call");
  };

  return (
    <div className="m-h-800 flex flex-col items-center">
      <h1 className="text-2xl">Verifying it&apos;s you</h1>

      <form onSubmit={handleVerifyOTP} className="w-full max-w-md">
        <div className="mt-6">
          <p className="mt-2 text-sm leading-7">
            For your security, we need to verify your identity. We&apos;ve sent
            a code to <b className="text-blue-700">{phone}</b>. Please enter it
            below.
          </p>
        </div>
        <div className="mt-6">
          <div className="mb-2 flex justify-between">
            <label className="text-xs text-gray-700">Enter Your Code</label>
            <span className="text-xs text-gray-500" onClick={handleResendCode}>
              Resend Code
            </span>
          </div>
          <div>
            <input
              type="text"
              required
              value={otp}
              onChange={handleOTPChange}
              onFocus={moveCaretAtEnd}
              className="h-10 w-full rounded bg-gray-200 px-4"
            />
          </div>
        </div>

        {(error || !otpValid) && (
          <div className="mt-6 w-full rounded-md border border-red-600">
            <div className="flex p-2">
              <div>
                <span>
                  <i className="material-icons pr-2 text-2xl text-red-600">
                    error
                  </i>
                </span>
              </div>
              <div>
                <span className="text-sm text-red-600">
                  There was a problem
                </span>
                <br />
                <span className="text-xs">
                  Your verification code is invalid
                </span>
              </div>
            </div>
          </div>
        )}

        <button
          type="submit"
          disabled={isAuthenticating}
          className="mt-6 h-12 w-full rounded-full bg-pink-600 font-medium text-white">
          Continue
        </button>
      </form>
    </div>
  );
};

const ForgotPassword = props => {
  const { openLink } = props;
  const auth = useSelector(state => state.auth);
  const actions = useActions({ resetPasswordRequest });
  const [userName, setUserName] = useState("");
  const [userNameValid, setUserNameValid] = useState(true);

  const moveCaretAtEnd = event => {
    const { value } = event.target;
    event.target.value = "";
    event.target.value = value;
  };

  const handleUserNameChange = event => {
    setUserName(event.target.value);
    setUserNameValid(true);
  };

  const handleResetPassword = event => {
    event.preventDefault();
    event.stopPropagation();
    const userNameValid =
      EmailValidator.validate(userName) ||
      parseInt(userName).toString().length === 10;
    if (userNameValid) {
      actions.resetPasswordRequest(userName, openLink);
    } else {
      setUserNameValid(userNameValid);
    }
  };

  return (
    <div className="m-h-800 flex flex-col items-center">
      <h1 className="text-2xl">Forgot Password</h1>
      {auth.error && (
        <div className="mt-6 w-full rounded-md border border-red-600">
          <div className="flex p-2">
            <div>
              <span>
                <i className="material-icons pr-2 text-2xl text-red-600">
                  error
                </i>
              </span>
            </div>
            <div>
              <span className="text-sm text-red-600">There was a problem</span>
              <br />
              <span className="text-xs">
                Invalid email address or phone number
              </span>
            </div>
          </div>
        </div>
      )}

      <form onSubmit={handleResetPassword} className="w-full max-w-md">
        <div className="mt-6">
          <label className="mb-2 text-xs text-gray-500">
            Email / Mobile Number
          </label>
          <div>
            <input
              type="text"
              required
              value={userName}
              onChange={handleUserNameChange}
              onFocus={moveCaretAtEnd}
              className="h-10 w-full rounded bg-gray-200 px-4"
            />
            {!userNameValid && (
              <span className="mt-2 block text-xs text-red-600">
                Invalid email address / mobile number
              </span>
            )}
          </div>
        </div>

        <button
          type="submit"
          disabled={auth.isAuthenticating}
          className="mt-6 h-12 w-full rounded-full bg-pink-600 font-medium text-white">
          Continue
        </button>
      </form>
      <div className="mt-6">
        <h6 className="text-sm leading-7 font-medium">
          Has your email address or mobile phone number changed?
        </h6>
        <p className="mt-2 text-sm leading-7">
          If you no longer have access to the email address or the phone number
          associated with your account, please contact our{" "}
          <Link to="/contact" className="text-sm font-semibold underline">
            Customer Service
          </Link>{" "}
          for restoring your account.
        </p>
      </div>
    </div>
  );
};

const ResetPassword = props => {
  const { isAuthenticating, error } = useSelector(state => state.auth);
  const actions = useActions({ resetPassword });
  const { location } = props;
  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [passwordValid, setPasswordValid] = useState(true);
  const [passwordAgainValid, setPasswordAgainValid] = useState(true);

  const moveCaretAtEnd = event => {
    const { value } = event.target;
    event.target.value = "";
    event.target.value = value;
  };

  const handleResetPassword = event => {
    event.preventDefault();
    event.stopPropagation();
    const passwordValid = password.length >= 6;
    const passwordAgainValid = password === passwordAgain;
    if (passwordValid && passwordAgainValid) {
      actions.resetPassword(password, location.query.token);
    } else {
      setPasswordValid(passwordValid);
      setPasswordAgainValid(passwordAgainValid);
    }
  };

  const handlePasswordChange = event => {
    setPassword(event.target.value);
    setPasswordValid(true);
  };

  const handlePasswordAgainChange = event => {
    setPasswordAgain(event.target.value);
    setPasswordValid(true);
  };

  return (
    <div className="m-h-800 flex flex-col items-center">
      <h1 className="text-2xl">Reset Password</h1>
      {error && (
        <div className="mt-6 w-full rounded-md border border-red-600">
          <div className="flex p-2">
            <div>
              <span>
                <i className="material-icons pr-2 text-2xl text-red-600">
                  error
                </i>
              </span>
            </div>
            <div>
              <span className="text-sm text-red-600">There was a problem</span>
              <br />
              <span className="text-xs">
                The reset password link is invalid.
              </span>
            </div>
          </div>
        </div>
      )}

      <form onSubmit={handleResetPassword} className="w-full max-w-md">
        <div className="mt-6">
          <label className="mb-2 text-xs text-gray-500">Password</label>
          <div>
            <input
              type="password"
              required
              value={password}
              onChange={handlePasswordChange}
              onFocus={moveCaretAtEnd}
              className="h-10 w-full rounded bg-gray-200 px-4"
            />
            {!passwordValid && (
              <span className="mt-2 block text-xs text-red-600">
                Password should have at least 6 characters
              </span>
            )}
          </div>
        </div>

        <div className="mt-6">
          <label className="mb-2 text-xs text-gray-500">
            Enter Password Again
          </label>
          <div>
            <input
              type="password"
              required
              value={passwordAgain}
              onChange={handlePasswordAgainChange}
              onFocus={moveCaretAtEnd}
              className="h-10 w-full rounded bg-gray-200 px-4"
            />
            {!passwordAgainValid && (
              <span className="mt-2 block text-xs text-red-600">
                Passwords do not match
              </span>
            )}
          </div>
        </div>

        <button
          type="submit"
          disabled={isAuthenticating}
          className="mt-6 h-12 w-full rounded-full bg-pink-600 font-medium text-white">
          Reset Password
        </button>
      </form>
    </div>
  );
};

const Auth = props => {
  const {
    location: { pathname }
  } = props;

  const isLogin = pathname === "/auth";

  const session = useSelector(state => state.auth.session);
  const logo = session?.options?.logo ?? baseLogo;

  return (
    <div className="relative flex min-h-screen flex-col overflow-hidden bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900">
      <header className="sticky top-0 z-50">
        <div className="mx-auto max-w-7xl">
          <nav className="flex items-center justify-between px-4 py-4 md:px-8">
            <div className="flex items-center">
              <Link
                to="/"
                className="relative h-10 w-10 transition-transform duration-300 hover:scale-105 md:h-14 md:w-14">
                <img
                  src={logo}
                  alt="Company Logo"
                  className="h-full w-full rounded-lg object-contain"
                />
              </Link>
            </div>
            {isLogin ? (
              <div className="flex items-center space-x-4">
                <div className="hidden sm:block">
                  <span className="text-white">
                    👶 New to <b>{session.appName}</b>
                  </span>
                </div>
                <Link to="/auth/signup">
                  <button className="rounded-full border-2 border-[#C1036D] bg-[#C1036D] px-6 py-2.5 font-medium text-white shadow-md hover:shadow-lg">
                    Create Account
                  </button>
                </Link>
              </div>
            ) : (
              <div className="flex items-center space-x-4">
                <div className="hidden sm:block">
                  <span className="text-white">Already have an account?</span>
                </div>
                <Link to="/auth">
                  <button className="group relative overflow-hidden rounded-full border-2 border-white px-6 py-2.5 font-medium text-white">
                    <span className="relative z-10">Login</span>
                  </button>
                </Link>
              </div>
            )}
          </nav>
        </div>
      </header>
      <main className="relative mt-10 flex flex-col items-center space-y-8 p-4 md:p-8">
        <div
          className="my-4 flex min-h-[50vh] w-full max-w-4xl flex-row rounded-lg bg-[#C1036D] bg-contain bg-no-repeat sm:px-16"
          style={{
            backgroundImage: `url(${backgroundImage})`
          }}>
          <div className="hidden flex-1 rounded-lg bg-transparent md:block">
            <div className="w-full px-8 py-16">
              <h2 className="text-xl font-medium text-white">
                Why choose <b>{session.appName}</b>?
              </h2>
              <p className="mt-4 text-base text-white/70">
                Start growing your business today with our powerful B2B
                e-commerce platform.
              </p>
            </div>
          </div>
          <div className="relative flex flex-1">
            <div className="absolute -top-10 flex min-h-[60vh] w-full rounded-lg border-1 border-gray-500 bg-white p-8">
              <div className="w-full">
                <Switch>
                  <Route exact path="/auth" component={Login} />
                  <Route path="/auth/signup" component={Signup} />
                  <Route
                    path="/auth/forgot-password"
                    component={ForgotPassword}
                  />
                  <Route
                    path="/auth/reset-password"
                    component={ResetPassword}
                  />
                  <Route path="/auth/verify-otp" component={VerifyOTP} />
                </Switch>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Auth;
